import {
  InfoCircleFilled,
  CheckOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import BaseButton from 'components/atoms/baseButton';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { FC } from 'react';

interface Props {
  total: number;
  added: number;
  updated: number;
  removed: number;

  lastSync?: string;
  source?: string;
  loadingAcceptAll?: boolean;
  loadingIgnoreAll?: boolean;
  disableAcceptAll?: boolean;
  disableIgnoreAll?: boolean;

  onAcceptAll: () => void;
  onIgnoreAll: () => void;
}

const MedicationReconciliationHeader: FC<Props> = ({
  total,
  added,
  updated,
  removed,
  lastSync,
  source,
  loadingAcceptAll,
  loadingIgnoreAll,
  disableAcceptAll,
  disableIgnoreAll,
  onAcceptAll,
  onIgnoreAll,
}) => {
  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>
      <div className={s.left}>
        <div className={s.icon}>
          <InfoCircleFilled />
        </div>

        <div>
          <div className={s['title-row']}>
            <div className={s.title}>{t('labels.medReconRequired')}</div>
            <div className={s.meta}>
              {lastSync && (
                <span>{t('labels.medReconLastImport', { lastSync })}</span>
              )}
              {source && <span>{t('labels.medReconSource', { source })}</span>}
            </div>
          </div>

          <div className={s.summary}>
            {t('labels.medReconFoundDifferences', { total })}
            <span>
              <span className={s.added}>●</span>{' '}
              {t('labels.medReconAddedCount', { count: added })}
            </span>
            <span>
              <span className={s.updated}>●</span>{' '}
              {t('labels.medReconUpdatedCount', { count: updated })}
            </span>
            <span>
              <span className={s.removed}>●</span>{' '}
              {t('labels.medReconRemovedCount', { count: removed })}
            </span>
          </div>
        </div>
      </div>

      <div className={s.right}>
        <BaseButton
          type="primary"
          className={s['accept-all']}
          icon={<CheckOutlined />}
          loading={loadingAcceptAll}
          disabled={disableAcceptAll}
          onClick={onAcceptAll}
          label={t('labels.medReconAcceptAll')}
        />

        <BaseButton
          icon={<CloseOutlined />}
          loading={loadingIgnoreAll}
          disabled={disableIgnoreAll}
          onClick={onIgnoreAll}
          label={t('labels.medReconIgnoreAll')}
          className={s['ignore-all']}
          type="secondary"
        />
      </div>
    </div>
  );
};

export default MedicationReconciliationHeader;
